import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { makeHoldTokenExpire } from "@/api/seats-io/seats-io";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { LogService } from "@/services/logging";
import BookingModule from "@/store/modules/booking";
import CashFloatModule from "@/store/modules/cash-float";
import CustomersModule from "@/store/modules/customers";
import FiskalyModule from "@/store/modules/fiskaly";
import POSConfigModule from "@/store/modules/pos-config";
import { handlePendingPaymentsCheck, bookings, maxBookingTabsToShow, selectBooking, canCreateNewBooking, canCloseBookingTab } from "@/utils/vue-helpers/booking";
import { cloneDeep } from "lodash";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import chevronDown from "@/assets/images/svg/chevron-down.svg";
import chevronUp from "@/assets/images/svg/chevron-up.svg";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import i18n from "@/lang";
import { BookingState } from "@/types/db/product-slot-booking";
import { processAbortEvent } from "@/utils/helpers/compliance"; // modules

export default defineComponent({
  name: "NavbarTabs",
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _useI18n, t, isDropdownVisible, draggedTabIndex, selectedBookingUUID, hasSalesStarted, currentChevron, maxBookingTabs, bookingVisibleTabs, bookingHiddenTabs, createNewBooking, closeTab, _closeTab, getTabClass, stopAnimation, showTabNameModal, getTabName, toggleDropDownMenu, onDragStart, onDrop;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onDrop = function _onDrop(index) {
                if (draggedTabIndex.value !== null) {
                  var uuid1 = bookings.value[index + bookings.value.length - maxBookingTabsToShow].uuid;
                  var uuid2 = bookings.value[draggedTabIndex.value + bookings.value.length - maxBookingTabsToShow].uuid;
                  BookingModule.swapBookings({
                    uuid1: uuid1,
                    uuid2: uuid2
                  });
                  draggedTabIndex.value = null; // Reset dragged index
                }
              };

              onDragStart = function _onDragStart(index) {
                draggedTabIndex.value = index;
              };

              toggleDropDownMenu = function _toggleDropDownMenu() {
                isDropdownVisible.value = !isDropdownVisible.value;
              };

              getTabName = function _getTabName(uuid) {
                var bookingCount = BookingModule.currentBookingCount;
                var defaultTabName = "".concat(i18n.global.t("tabs.order"), " #").concat(bookingCount);

                if (!uuid) {
                  BookingModule.setBookingTabName(defaultTabName);
                  return defaultTabName;
                }

                var bookingTabName = BookingModule.bookings[uuid].tabName;

                if (!bookingTabName) {
                  // set booking tab name to default one so it doesn't change with index change
                  BookingModule.setBookingTabName(defaultTabName);
                  return defaultTabName;
                }

                return bookingTabName;
              };

              showTabNameModal = function _showTabNameModal(uuid) {
                if (uuid === selectedBookingUUID.value) {
                  ModalModule.setStatus(ModalStatus.TabNameEdit);
                }
              };

              stopAnimation = function _stopAnimation() {
                BookingModule.setTabAnimation(false);
              };

              getTabClass = function _getTabClass(uuid) {
                var className = "";

                if (bookings.value.length === 1 || uuid === BookingModule.selectedBookingUUID) {
                  className = "selected-tab";

                  if (BookingModule.isTabAnimated) {
                    className = "selected-tab tab-with-animation"; // Lets now set the animation to false after making sure the animation has finished

                    setTimeout(stopAnimation, 1700);
                  }
                } else {
                  className = "unselected-tab";
                }

                return className;
              };

              _closeTab = function _closeTab3() {
                _closeTab = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var completedBooking, _yield$handlePendingP, canClose, promptedForConfirmation, selectedCustomer, res, nextBookingUUID;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (canCloseBookingTab()) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return");

                        case 2:
                          completedBooking = cloneDeep(BookingModule.selectedBooking);

                          if (completedBooking) {
                            _context.next = 5;
                            break;
                          }

                          throw new Error(PSBErrors.NoBookingInModule);

                        case 5:
                          LogService.info("User clicked on Close Tab button to remove the booking, booking: ".concat(completedBooking.uuid)); // we check if need to prompt user for confirmation if booking is partially paid or has pending adyen payments

                          _context.next = 8;
                          return handlePendingPaymentsCheck(completedBooking);

                        case 8:
                          _yield$handlePendingP = _context.sent;
                          canClose = _yield$handlePendingP.canClose;
                          promptedForConfirmation = _yield$handlePendingP.promptedForConfirmation;

                          if (canClose) {
                            _context.next = 14;
                            break;
                          }

                          console.log("user shouldn't close");
                          return _context.abrupt("return");

                        case 14:
                          if (!(!promptedForConfirmation && BookingModule.currentOrderSessionId && completedBooking.state !== BookingState.Completed)) {
                            _context.next = 23;
                            break;
                          }

                          _context.prev = 15;
                          _context.next = 18;
                          return processAbortEvent(completedBooking, BookingModule.currentOrderSessionId);

                        case 18:
                          _context.next = 23;
                          break;

                        case 20:
                          _context.prev = 20;
                          _context.t0 = _context["catch"](15);
                          LogService.info("Error processing ABORT event", {
                            error: _context.t0
                          });

                        case 23:
                          console.log("removing booking"); // remove customer of the booking

                          selectedCustomer = CustomersModule.selectedCustomers.find(function (c) {
                            return c.bookingUuid === completedBooking.uuid;
                          });

                          if (selectedCustomer) {
                            CustomersModule.removeSelectedCustomer(selectedCustomer);
                          } // remove previous booking


                          BookingModule.removeBooking(completedBooking); // Create new booking if we have only one booking

                          if (bookings.value.length === 0) {
                            BookingModule.resetBookingCount();
                            BookingModule.createNewBooking();
                          } // We need to remove the booking receipt signature from Fiskaly state


                          FiskalyModule.removeSignatureQrCodes(completedBooking.uuid); // remove the transaction from Fiskaly state

                          FiskalyModule.removeTransaction(completedBooking.uuid); // Now if the booking in some moment of its life the user selected a seat from a chart without confirming its PSS
                          // then we should make its holdToken expires immediately so that seats io release the held seats (only held seats, booked seats will not be released by this)

                          if (!(completedBooking.seatsIoHoldToken && completedBooking.seatsIoHoldToken.holdToken)) {
                            _context.next = 34;
                            break;
                          }

                          _context.next = 33;
                          return makeHoldTokenExpire(completedBooking.seatsIoHoldToken.holdToken);

                        case 33:
                          res = _context.sent;

                        case 34:
                          // TODO select the last created booking
                          nextBookingUUID = bookings.value[bookings.value.length - 1].uuid;
                          selectBooking(nextBookingUUID); // BookingModule.setBookingStep(BookingStep.Order);

                        case 36:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[15, 20]]);
                }));
                return _closeTab.apply(this, arguments);
              };

              closeTab = function _closeTab2() {
                return _closeTab.apply(this, arguments);
              };

              createNewBooking = function _createNewBooking() {
                if (!canCreateNewBooking()) {
                  return;
                }

                BookingModule.createNewBooking();
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              isDropdownVisible = ref(false);
              draggedTabIndex = ref(null);
              selectedBookingUUID = computed(function () {
                return BookingModule.selectedBookingUUID;
              });
              hasSalesStarted = computed(function () {
                return CashFloatModule.cashFloat;
              });
              currentChevron = computed(function () {
                return isDropdownVisible.value ? chevronUp : chevronDown;
              });
              maxBookingTabs = computed(function () {
                return POSConfigModule.maxBookingTabs;
              });
              bookingVisibleTabs = computed(function () {
                return BookingModule.bookingVisibleTabs;
              });
              bookingHiddenTabs = computed(function () {
                return BookingModule.bookingHiddenTabs;
              });
              return _context2.abrupt("return", {
                t: t,
                bookings: bookings,
                selectedBookingUUID: selectedBookingUUID,
                createNewBooking: createNewBooking,
                selectBooking: selectBooking,
                closeTab: closeTab,
                hasSalesStarted: hasSalesStarted,
                getTabClass: getTabClass,
                editPen: editPen,
                currentChevron: currentChevron,
                showTabNameModal: showTabNameModal,
                getTabName: getTabName,
                isDropdownVisible: isDropdownVisible,
                toggleDropDownMenu: toggleDropDownMenu,
                maxBookingTabs: maxBookingTabs,
                maxBookingTabsToShow: maxBookingTabsToShow,
                bookingVisibleTabs: bookingVisibleTabs,
                bookingHiddenTabs: bookingHiddenTabs,
                draggedTabIndex: draggedTabIndex,
                onDragStart: onDragStart,
                onDrop: onDrop
              });

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});